
const SCHOOL_DEPARTMENTS = [
    { id: 1, name: "Applied Technologies"},
    { id: 2, name: "Accounting"},
    { id: 3, name: "Adult Basic Education"},
    { id: 4, name: "Alternative Teacher License"},
    { id: 5, name: "American Studies"},
    { id: 6, name: "Anthropology"},
    { id: 7, name: "Arch/Engr Drafting Technology"},
    { id: 8, name: "Artificial Intelligence and Machine Learning Certificate"},
    { id: 9, name: "Automotive Technology"},
    { id: 10, name: "Aviation Technology"},
    { id: 11, name: "Biology"},
    { id: 12, name: "Brewing &amp; Beverage Management"},
    { id: 13, name: "Business"},
    { id: 14, name: "Career Technical"},
    { id: 15, name: "Carpentry"},
    { id: 16, name: "Chemistry"},
    { id: 17, name: "Chicana and Chicano Studies"},
    { id: 17, name: "Communication"},
    { id: 18, name: "Community Health Worker"},
    { id: 20, name: "Computer Information Systems"},
    { id: 21, name: "Computer Science"},
    { id: 22, name: "Construction Management Technology"},
    { id: 23, name: "Cosmetology"},
    { id: 24, name: "Criminal Justice"},
    { id: 25, name: "Criminology"},
    { id: 26, name: "Culinary Arts"},
    { id: 27, name: "Dental Sciences"},
    { id: 28, name: "Developmental Education"},
    { id: 29, name: "Diagnostic Medical Sonography"},
    { id: 30, name: "Diesel Equipment Technology"},
    { id: 31, name: "Early Childhood Multicultural Education"},
    { id: 32, name: "Earth and Planetary Science"},
    { id: 33, name: "Electrical Trades"},
    { id: 34, name: "Electroneurodiagnostic Technology"},
    { id: 35, name: "Electronics Technology"},
    { id: 36, name: "Emergency Medical Services"},
    { id: 37, name: "English"},
    { id: 38, name: "Environmental Planning and Design"},
    { id: 39, name: "Exercise Science &amp; Wellness"},
    { id: 40, name: "Film Technician"},
    { id: 41, name: "Fine Arts"},
    { id: 42, name: "Fire Science"},
    { id: 43, name: "Geographic Information Technology"},
    { id: 44, name: "Geography"},
    { id: 45, name: "Health Information Technology"},
    { id: 46, name: "Health Services Management"},
    { id: 47, name: "Health Wellness Public Safety"},
    { id: 48, name: "Heating, Ventilating, Air Conditioning &amp; Refrigeration"},
    { id: 49, name: "History"},
    { id: 50, name: "Hospitality and Tourism"},
    { id: 51, name: "Human Services"},
    { id: 52, name: "Integrated Studies"},
    { id: 53, name: "Latin American Studies"},
    { id: 54, name: "Liberal Arts"},
    { id: 55, name: "Machine Tool Technology"},
    { id: 56, name: "Mathematical Sciences"},
    { id: 57, name: "Mathematics"},
    { id: 58, name: "Medical Assistant"},
    { id: 59, name: "Medical Laboratory Sciences"},
    { id: 60, name: "Modern Languages"},
    { id: 61, name: "Music"},
    { id: 62, name: "Native American Studies"},
    { id: 63, name: "Natural Science"},
    { id: 64, name: "Nursing"},
    { id: 65, name: "Nursing Assistant"},
    { id: 66, name: "Nutrition"},
    { id: 67, name: "Office Administration"},
    { id: 68, name: "Online Teaching & Learning"},
    { id: 69, name: "Paralegal Studies"},
    { id: 70, name: "Patient Care Technician"},
    { id: 71, name: "Pharmacy Sciences"},
    { id: 72, name: "Physical Therapist Assistant"},
    { id: 73, name: "Physics"},
    { id: 74, name: "Plumbing and Gas Fitting"},
    { id: 75, name: "Political Science"},
    { id: 76, name: "Pre-Architecture"},
    { id: 77, name: "Pre-Law"},
    { id: 78, name: "Psychology"},
    { id: 79, name: "Radiologic Technology"},
    { id: 80, name: "Respiratory Care"},
    { id: 81, name: "Sociology"},
    { id: 82, name: "Surgical Sciences"},
    { id: 83, name: "Surveying Technology"},
    { id: 84, name: "Teacher Education"},
    { id: 85, name: "Theatre"},
    { id: 86, name: "Truck Driving"},
    { id: 87, name: "Unmanned Aircraft Systems"},
    { id: 88, name: "Veterinary Sciences"},
    { id: 89, name: "Welding"},
]

export function fetchAllDepartments() {
    return SCHOOL_DEPARTMENTS;
}

export function findDepartment(departmentId) {
    return SCHOOL_DEPARTMENTS.find(dept => dept.id == departmentId)
}

export function findDepartmentByName(departmentName) {
    return SCHOOL_DEPARTMENTS.find(dept => dept.name === departmentName)
}
